export const HEADS_DATA = [
  "name",
  "contact",
  "email",
  "channels",
  "First added on",
  "Last seen",
];

export const ALLOWED_WIDGETS = ["phone", "plivo_call", "telnyx_call","sip"];
